"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Field_1 = require("../../constants/Field");
var FunctionInputs_1 = require("./FunctionInputs");
var DataItem_1 = require("../common/base/DataItem");
var lodash_1 = require("lodash");
var FunctionOutputs_1 = require("./FunctionOutputs");
var DataType_1 = require("../common/base/DataType");
var Triggers_1 = require("./Triggers");
var Inhibit_1 = require("./Inhibit");
var Types_1 = require("../../api/Types");
var ModelConstants_1 = require("../../constants/ModelConstants");
var DeepCopy_1 = require("../common/lib/DeepCopy");
var InhibitType;
(function (InhibitType) {
    InhibitType[InhibitType["Reference"] = 0] = "Reference";
    InhibitType[InhibitType["Actual"] = 1] = "Actual";
})(InhibitType || (InhibitType = {}));
var ComputeFunction = /** @class */ (function () {
    function ComputeFunction() {
        //
    }
    ComputeFunction.fromJson = function (name, json, isInstance, objectInstanceIds) {
        var computeFunction = new ComputeFunction();
        computeFunction.name = name;
        computeFunction.version = DataItem_1.DataItem.fromJson(Field_1.FIELD.VERSION, json[Field_1.FIELD.VERSION]);
        computeFunction.functionType = DataItem_1.DataItem.fromJson(Field_1.FIELD.FUNCTIONTYPE, json[Field_1.FIELD.FUNCTIONTYPE]);
        if (json[Field_1.FIELD.ENDPOINT] !== undefined) {
            computeFunction.endpoint = DataItem_1.DataItem.fromJson(Field_1.FIELD.ENDPOINT, json[Field_1.FIELD.ENDPOINT]);
        }
        computeFunction.inputs = FunctionInputs_1.FunctionInputs.fromJson(json[Field_1.FIELD.INPUTS], isInstance, objectInstanceIds);
        computeFunction.outputs = FunctionOutputs_1.FunctionOutputs.fromJson(json[Field_1.FIELD.OUTPUTS]);
        // if (computeFunction.inputs.conditions) {
        //     computeFunction.outputs.conditions = map(computeFunction.inputs.conditions, conditionIn => {
        //         const conditionOut = conditionIn.toConditionOut();
        //         conditionOut.referToVariables(computeFunction.name);
        //         return conditionOut;
        //     });
        // }
        if (json[Field_1.FIELD.TRIGGERS]) {
            computeFunction.triggers = Triggers_1.Triggers.fromJson(json[Field_1.FIELD.TRIGGERS]);
        }
        if (json[Field_1.FIELD.INHIBIT]) {
            computeFunction.inhibit = Inhibit_1.Inhibit.fromJson(json[Field_1.FIELD.INHIBIT], isInstance, objectInstanceIds);
        }
        return computeFunction;
    };
    ComputeFunction.clearConnections = function (functionJson, connectionGuid) {
        var sceFunction = DeepCopy_1.deepCopy(functionJson);
        sceFunction.inputs = FunctionInputs_1.FunctionInputs.clearConnections(DeepCopy_1.deepCopy(sceFunction.inputs), connectionGuid);
        return this.clearInhibitAndTriggerConnections(sceFunction);
    };
    ComputeFunction.updateConnections = function (functionJson, connectionGuids, targetObjectType) {
        var sceFunction = DeepCopy_1.deepCopy(functionJson);
        sceFunction.inputs = FunctionInputs_1.FunctionInputs.updateConnections(DeepCopy_1.deepCopy(sceFunction.inputs), connectionGuids, targetObjectType);
        return this.updateInhibitAndTriggerConnections(sceFunction, connectionGuids, targetObjectType);
    };
    ComputeFunction.clearInhibitAndTriggerConnections = function (sceFunction) {
        if (sceFunction.inhibit) {
            if (sceFunction.inhibit.referenceValue &&
                sceFunction.inhibit.referenceValue.link) {
                if (sceFunction.triggers && sceFunction.triggers.variableChange) {
                    delete sceFunction.triggers.variableChange.referenceValue;
                }
                delete sceFunction.inhibit.referenceValue;
            }
            if (sceFunction.inhibit.actualValue &&
                sceFunction.inhibit.actualValue.link) {
                if (sceFunction.triggers && sceFunction.triggers.variableChange) {
                    delete sceFunction.triggers.variableChange.actualValue;
                }
                delete sceFunction.inhibit.actualValue;
            }
        }
        if (sceFunction.inhibit && lodash_1.isEmpty(sceFunction.inhibit)) {
            delete sceFunction.inhibit;
        }
        if (sceFunction.triggers &&
            sceFunction.triggers.variableChange &&
            lodash_1.isEmpty(sceFunction.triggers.variableChange)) {
            delete sceFunction.triggers.variableChange;
        }
        return sceFunction;
    };
    ComputeFunction.updateInhibitAndTriggerConnections = function (sceFunction, connectionGuids, targetObjectType) {
        if (sceFunction.inhibit &&
            sceFunction.inhibit.referenceValue &&
            sceFunction.inhibit.referenceValue.link) {
            sceFunction = this.updateInhibitVariable(connectionGuids, sceFunction, targetObjectType, InhibitType.Reference);
        }
        if (sceFunction.inhibit && sceFunction.inhibit.actualValue &&
            sceFunction.inhibit.actualValue.link) {
            sceFunction = this.updateInhibitVariable(connectionGuids, sceFunction, targetObjectType, InhibitType.Actual);
        }
        if (sceFunction.inhibit && lodash_1.isEmpty(sceFunction.inhibit)) {
            delete sceFunction.inhibit;
        }
        if (sceFunction.triggers &&
            sceFunction.triggers.variableChange &&
            lodash_1.isEmpty(sceFunction.triggers.variableChange)) {
            delete sceFunction.triggers.variableChange;
        }
        return sceFunction;
    };
    ComputeFunction.updateInhibitVariable = function (connectionGuids, sceFunction, targetObjectType, inhibitType) {
        if (sceFunction.inhibit === undefined) {
            return sceFunction;
        }
        var inhibitVariable = inhibitType === InhibitType.Reference ?
            sceFunction.inhibit.referenceValue :
            sceFunction.inhibit.actualValue;
        if (inhibitVariable === undefined) {
            return sceFunction;
        }
        var linkValue = inhibitVariable.link;
        if (linkValue === undefined) {
            return sceFunction;
        }
        var connectedGuid = lodash_1.find(connectionGuids, function (o) { return linkValue.includes(o); });
        if (connectedGuid === undefined) {
            return sceFunction;
        }
        var linkedVariable = linkValue.split('/');
        var linkedVariableName = linkedVariable[linkedVariable.length - 1];
        var nodes = lodash_1.get(targetObjectType, "variables.nodes", []);
        var matchedPath = nodes.length > 0
            ? targetObjectType.variables.getPathForMatchingVariable(linkedVariableName, inhibitVariable.dataType, connectedGuid)
            : null;
        if (matchedPath !== null) {
            inhibitVariable.link = matchedPath;
            if (inhibitType === InhibitType.Reference) {
                sceFunction.inhibit.referenceValue = inhibitVariable;
            }
            else {
                sceFunction.inhibit.actualValue = inhibitVariable;
            }
        }
        else {
            if (sceFunction.triggers && sceFunction.triggers.variableChange) {
                if (inhibitType === InhibitType.Reference) {
                    delete sceFunction.triggers.variableChange.referenceValue;
                }
                else {
                    delete sceFunction.triggers.variableChange.actualValue;
                }
            }
            if (inhibitType === InhibitType.Reference) {
                delete sceFunction.inhibit.referenceValue;
            }
            else {
                delete sceFunction.inhibit.actualValue;
            }
        }
        return sceFunction;
    };
    ComputeFunction.prototype.toJson = function (includeOnlyVariableData) {
        var json = Object.create(null);
        var amFunction = Object.assign({}, this.functionTypeToJson(includeOnlyVariableData), this.endpointTypeToJson(includeOnlyVariableData), this.inputsToJson(includeOnlyVariableData), this.outputsToJson(includeOnlyVariableData), this.triggersToJson(includeOnlyVariableData), this.inhibitToJson(includeOnlyVariableData));
        json[this.name.replace(/\s/g, "")] = amFunction;
        return json;
    };
    ComputeFunction.prototype.functionTypeToJson = function (includeOnlyValueOrLink) {
        var json = Object.create(null);
        json[Field_1.FIELD.FUNCTIONTYPE] = this.functionType.toJson(includeOnlyValueOrLink);
        return json;
    };
    ComputeFunction.prototype.endpointTypeToJson = function (includeOnlyValueOrLink) {
        var json = Object.create(null);
        if (this.endpoint === undefined) {
            return json;
        }
        if (this.endpoint.isDirty === true || this.endpoint.isDirty === undefined) {
            json[Field_1.FIELD.ENDPOINT] = this.endpoint.toJson(includeOnlyValueOrLink);
        }
        return json;
    };
    ComputeFunction.prototype.inputsToJson = function (includeOnlyValueOrLink) {
        var inputs = this.inputs.toJson(includeOnlyValueOrLink);
        var json = Object.create(null);
        json[Field_1.FIELD.INPUTS] = inputs;
        return json;
    };
    ComputeFunction.prototype.outputsToJson = function (includeOnlyVariableData) {
        if (includeOnlyVariableData) {
            return Object.create(null);
        }
        var outputs = this.outputs.toJson();
        var json = Object.create(null);
        json[Field_1.FIELD.OUTPUTS] = outputs;
        return json;
    };
    ComputeFunction.prototype.triggersToJson = function (includeOnlyValueOrLink) {
        if (this.triggers) {
            var json = Object.create(null);
            var triggersJson = this.triggers.toJson(includeOnlyValueOrLink);
            if (!lodash_1.isEmpty(triggersJson)) {
                json[Field_1.FIELD.TRIGGERS] = triggersJson;
            }
            return json;
        }
        return Object.create(null);
    };
    ComputeFunction.prototype.inhibitToJson = function (includeOnlyValueOrLink) {
        if (this.inhibit) {
            var json = Object.create(null);
            json[Field_1.FIELD.INHIBIT] = this.inhibit.toJson(includeOnlyValueOrLink);
            return json;
        }
        return Object.create(null);
    };
    /**
     * To be used when linkedVariables dataType is other than 'array'. Checks if linked
     * variable is refering to any output. If yes, creates and returns its respective storage
     * variable.
     * @param linkedVariable
     * @param linkPath link path pointing to the output variable
     * @returns Storage variable pointing to an output variable.
     */
    ComputeFunction.prototype.createStorageVariable = function (linkPath, linkedVariable) {
        if (lodash_1.isEmpty(linkPath)) {
            return undefined;
        }
        var linkIndex = this.getLinkedOutputIndex(linkPath);
        if (linkIndex !== -1) {
            var output = this.outputs.outputs[linkIndex];
            return this.updateInputVariableAndGetStorageVariable(output, linkedVariable, linkPath);
        }
        return undefined;
    };
    ComputeFunction.prototype.fetchFunctionType = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var type, typeSplit, typeId, version, types, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        type = this.functionType.value;
                        typeSplit = type.split("@");
                        typeId = typeSplit[0];
                        version = typeSplit[1];
                        types = new Types_1.Types();
                        return [4 /*yield*/, types
                                .getTypeDetails(ModelConstants_1.ModelConstants.FunctionTypeModel, typeId, version)
                                .catch(function (error) {
                                throw new Error("Failed to fetch function type with type " + type + " for given model");
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ComputeFunction.prototype.updateStorageVariable = function (storageVariable, name, outputLinkPath) {
        storageVariable.description = undefined;
        storageVariable.name = name;
        storageVariable.link = outputLinkPath;
        return storageVariable;
    };
    ComputeFunction.prototype.updateInputVariableAndGetStorageVariable = function (output, inputVariable, linkPath) {
        var storageVariableName = this.name + "_" + output.name;
        var storageVariable = this.updateStorageVariable(output.clone(), storageVariableName, linkPath);
        if (inputVariable.dataType === DataType_1.DataType.array) {
            inputVariable.updateLinkFromArrayOfLinks(linkPath, "#/properties/storage/" + storageVariableName);
        }
        else {
            inputVariable.link = "#/properties/storage/" + storageVariableName;
        }
        return storageVariable;
    };
    /**
     * Checks if any output variables' path matches given link path and returns its index if true.
     * @param link link path
     * @returns Output index if condition satisfied else -1
     */
    ComputeFunction.prototype.getLinkedOutputIndex = function (link) {
        var outputPath = "#/properties/functions/" + this.name + "/outputs/";
        var linkIndex = lodash_1.findIndex(this.outputs.outputs, function (output) {
            return link === outputPath + output.name;
        });
        return linkIndex;
    };
    return ComputeFunction;
}());
exports.ComputeFunction = ComputeFunction;
//# sourceMappingURL=ComputeFunction.js.map